var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5779_6270",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 77C46.5971 77.0057 51.15 76.103 55.3972 74.3437C59.6443 72.5844 63.502 70.0032 66.7485 66.7485C70.0032 63.502 72.5844 59.6443 74.3437 55.3972C76.103 51.15 77.0057 46.5971 77 42C77.0057 37.4029 76.103 32.85 74.3437 28.6029C72.5844 24.3557 70.0032 20.4981 66.7485 17.2515C63.502 13.9968 59.6443 11.4157 55.3972 9.65638C51.15 7.8971 46.5971 6.99436 42 7.00003C37.4029 6.99436 32.85 7.8971 28.6029 9.65638C24.3557 11.4157 20.4981 13.9968 17.2515 17.2515C13.9968 20.4981 11.4157 24.3557 9.65638 28.6029C7.8971 32.85 6.99436 37.4029 7.00003 42C6.99436 46.5971 7.8971 51.15 9.65638 55.3972C11.4157 59.6443 13.9968 63.502 17.2515 66.7485C20.4981 70.0032 24.3557 72.5844 28.6029 74.3437C32.85 76.103 37.4029 77.0057 42 77Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42L38.5 52.5L59.5 31.5",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5779_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84V84H0V0Z",
    fill: "#724AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bf50ce6694defd77c938b79b5e53f1c0.svg";
export { ForwardRef as ReactComponent };